import type { Guia } from '../tipos';

export const guiaIndicadores: Guia = {
  id: 'indicadores',
  titulo: 'Indicadores e nascidos vivos',
  resumo:
    'Indicadores de eliminação da transmissão vertical, metas e selos, e como informar os nascidos vivos.',
  perfis: ['gestor', 'gestor_regional', 'visualizador', 'medico', 'enfermeiro'],
  revisadoEm: '2026-10-17',
  secoes: [
    {
      id: 'ver',
      titulo: 'Ver os indicadores',
      passos: [
        'No menu, abra **Indicadores** e escolha o **Ano** e o **Município de residência**.',
        'Cada indicador mostra o valor, a meta e o selo (ouro, prata, bronze ou ainda não atingido).',
        'Contagens menores que 5 aparecem como "< 5", para não identificar pessoas.',
      ],
      imagem: {
        arquivo: 'indicadores.png',
        descricao: 'Página de indicadores com o valor, a meta e o selo de cada indicador.',
      },
    },
    {
      id: 'nascidos-vivos',
      titulo: 'Informar os nascidos vivos (SINASC)',
      passos: [
        'A incidência de sífilis congênita usa os nascidos vivos do SINASC como denominador.',
        'O gestor informa o número do ano em **Nascidos vivos (SINASC)** e clica em **Gravar**.',
        'Para vários municípios ou anos, use **Escolher planilha** com as colunas codigo_ibge;ano;nascidos_vivos, exportada do TabNet.',
      ],
      observacao: 'Corrigir um número guarda o valor anterior na auditoria.',
      botoes: ['Gravar', 'Escolher planilha'],
    },
  ],
};

export const guiaTitular: Guia = {
  id: 'titular',
  titulo: 'Pedidos do titular (LGPD) e anexos',
  resumo:
    'Registrar e responder pedidos de acesso aos dados, relatório de acessos e cópia do prontuário; anexar arquivos.',
  perfis: ['gestor', 'medico', 'enfermeiro'],
  revisadoEm: '2026-10-17',
  secoes: [
    {
      id: 'registrar',
      titulo: 'Registrar o pedido',
      passos: [
        'Abra a ficha da pessoa e clique em **Registrar pedido do titular (LGPD)**.',
        'Informe quem pediu, a relação com a pessoa e como a identidade foi conferida, e clique em **Registrar pedido**.',
        'O prazo de resposta é de 15 dias e aparece em **Pedidos do titular (LGPD)**, no menu.',
      ],
      observacao: 'Só o gestor do município atende os pedidos do titular.',
      botoes: ['Registrar pedido do titular (LGPD)', 'Registrar pedido'],
      imagem: {
        arquivo: 'titular.png',
        descricao: 'Lista de pedidos do titular com o tipo, o prazo e a situação.',
      },
    },
    {
      id: 'responder',
      titulo: 'Responder',
      passos: [
        'Abra o pedido. Conforme o tipo, use **Gerar relatório de acessos** (quem viu os dados) ou **Gerar cópia do prontuário**.',
        'Entregue com **Imprimir ou salvar em PDF** ou **Baixar em arquivo (JSON)**.',
        'Registre o que foi entregue em **Registrar resposta**.',
      ],
      botoes: [
        'Gerar relatório de acessos',
        'Gerar cópia do prontuário',
        'Imprimir ou salvar em PDF',
        'Registrar resposta',
      ],
    },
    {
      id: 'anexos',
      titulo: 'Anexar arquivos',
      passos: [
        'Na ficha, abra a aba **Anexos**, escolha o arquivo (PDF, JPEG ou PNG, até 10 MB), o tipo e uma descrição e clique em **Anexar**.',
        'O arquivo fica guardado de forma cifrada e só abre pelo sistema, com o registro de quem abriu.',
      ],
      botoes: ['Anexar'],
      imagem: {
        arquivo: 'anexos.png',
        descricao: 'Aba Anexos da ficha com a lista de arquivos anexados.',
      },
    },
  ],
};
